export interface CalcResult {
    monthlyPayment: number,
    totalAmount: number,
    overPayment: number
}

export interface CreditCalcResult {
    annuity: CalcResult,
    differentiated: CalcResult
}

export interface DepositCalcResult {
    depositTotalAmount: number;
    depositInterestTotal: number;
    averageDepositReward: number;
    interests: {
        period: number;
        interestSum: number;
        amount: number;
    }[]
}

export const onCalculateLoan = (amount: number, rate: number, period: number, daysInMonth: number, daysInYear: number): CreditCalcResult => {
    let calcResult: CalcResult = { monthlyPayment: 0, totalAmount: 0, overPayment: 0 }
    let result: CreditCalcResult = { annuity: calcResult, differentiated: calcResult }
    let monthlyRate = rate / 12 / 100
    let coefficient = calcAnnuityCoefficient(monthlyRate, period)

    result = {
        annuity: {
            monthlyPayment: coefficient * amount,
            totalAmount: (coefficient * amount) * period,
            overPayment: (coefficient * amount * period) - amount
        },
        differentiated: {
            monthlyPayment: (amount + calcLoanInterest(amount, rate, period, daysInMonth, daysInYear)) / period,
            totalAmount: amount + calcLoanInterest(amount, rate, period, daysInMonth, daysInYear),
            overPayment: calcLoanInterest(amount, rate, period, daysInMonth, daysInYear)
        }
    }
    return result;
}

const calcAnnuityCoefficient = (coefficient: number, period: number): number => {
    return (coefficient * Math.pow((1 + coefficient), period)) / (Math.pow((1 + coefficient), period) - 1)
}

const calcLoanInterest = (amount: number, rate: number, period: number, daysInMonth: number, daysInYear: number): number => {
    let monthlyEqualPayment = amount / period
    let loanInterest = 0

    while (amount > 0) {
        loanInterest += amount * (rate / 100) * daysInMonth / daysInYear
        amount -= monthlyEqualPayment
    }
    return loanInterest;
}

/**
 * onCalculateDeposit Function
 * @param amount Deposit amount
 * @param rate Deposit annual interest rate (example: 9%, passed as 9)
 * @param period Deposit term
 * @param daysInMonth Days in month for calculation
 * @param daysInYear Days in year for calculation
 */
export const onCalculateDeposit = (
    amount: number, 
    rate: number, 
    period: number, 
    daysInMonth: number, 
    daysInYear: number,
    capitalize: boolean): DepositCalcResult => {
    const interests = [];
    
    let interestSum = 0

    for (let i = 1; i <= period; i++) {
        interestSum += (amount * (rate / 100) * daysInMonth) / daysInYear;

        interests.push({
            period: i,
            interestSum: (amount * (rate / 100) * daysInMonth) / daysInYear,
            amount: capitalize ?
                amount += (amount * (rate / 100) * daysInMonth) / daysInYear :
                amount
        })

        if (capitalize) amount += (amount * (rate / 100) * daysInMonth) / daysInYear;
    }

    let result: DepositCalcResult = {
        depositInterestTotal: interestSum,
        depositTotalAmount: amount + interestSum,
        averageDepositReward: interestSum / period,
        interests
    }

    return result
}